import { type FC, useEffect } from 'react';
import { Card } from '@george-labs.com/design-system';

import type { BankMessage } from '../BankMessagesTypes';
import { isBankMessageUnread } from '../BankMessagesService';
import { BankMessageIcon } from '../BankMessageIcon';
import { BankMessageContent } from './BankMessageContent';

interface Props {
    message: BankMessage;
    showIcon?: boolean;
    onAttachmentDownload(messageId: string, attachmentId: string): void;
    onBankMessageDisplayed(messageId: string, read: boolean): void;
}

export const BankMessageView: FC<Props> = ({
    message,
    showIcon,
    onAttachmentDownload,
    onBankMessageDisplayed,
}) => {
    useEffect(() => {
        onBankMessageDisplayed(message.id, !isBankMessageUnread(message.flags));
    }, []);

    return (
        <div className="d-flex">
            {showIcon && <BankMessageIcon flags={message.flags} className="mt-4" />}
            <Card padding={Card.PADDING.LARGE}>
                <BankMessageContent message={message} onAttachmentDownload={onAttachmentDownload} />
            </Card>
        </div>
    );
};
